export interface ConsoleConfig {
  clerkPublishableKey: string;
  backendOrigin: string;
  // Absent until the Meta app is provisioned — see ADR 0004. The WhatsApp connect step
  // renders an explicit "not configured" state rather than failing at FB.login time.
  metaAppId: string | null;
  metaConfigId: string | null;
  googleMapsApiKey: string | null;
}

export async function loadConsoleConfig(): Promise<ConsoleConfig> {
  const response = await fetchConfig();

  if (!response.ok) {
    throw new Error('Não foi possível abrir sua área da loja agora. Tente novamente em instantes.');
  }

  const config = (await response.json()) as Partial<ConsoleConfig>;

  if (!config.clerkPublishableKey) {
    throw new Error('Não foi possível iniciar sua sessão agora. Tente novamente em instantes.');
  }

  if (!config.backendOrigin) {
    throw new Error('Não foi possível conectar sua área da loja. Tente novamente em instantes.');
  }

  return {
    clerkPublishableKey: config.clerkPublishableKey,
    backendOrigin: trimTrailingSlashes(config.backendOrigin),
    metaAppId: config.metaAppId ?? null,
    metaConfigId: config.metaConfigId ?? null,
    googleMapsApiKey: config.googleMapsApiKey ?? null,
  };
}

/** A network failure rejects with "Failed to fetch"; the lojista reads plain Portuguese instead. */
async function fetchConfig(): Promise<Response> {
  try {
    return await fetch('/console-config.json', { cache: 'no-store' });
  } catch {
    throw new Error('Não foi possível abrir sua área da loja. Verifique sua conexão e tente novamente.');
  }
}

function trimTrailingSlashes(origin: string): string {
  return origin.replace(/\/+$/u, '');
}
